export default __webpack_public_path__ + "static/media/fintech-icon-02.ed8251cf.svg";